import {WizardBaseStep} from "../../../../models/wizard/wizard-base.step";
import {BookingModel} from "../../models/booking.model";
import {Wizard} from "../../../../models/wizard/wizard";
import {IRoute} from "../../../navigation/models/route.interface";
import {IRouteActivationOptions} from "../../../navigation/navigator.service.interface";
import {IOnBeforeDeactivationContext} from "../../../../models/wizard/wizard.step.interface";
import {DialogResult} from "../../../dialog/dialog-enums";
import {YesNoDialogPrimaryButton, YesNoDialogResult} from "../../../dialog-factory/yes-no-dialog.enums";


export abstract class BookingStepBase extends WizardBaseStep {
    constructor(protected readonly booking: BookingModel, wizard: Wizard) {
        super(booking.services, wizard);
    }

    protected _activateStepByRoute(route: IRoute, activateOptions?: IRouteActivationOptions): void {
        const finalPriceRoute = this.booking.bookingStrategyAdapter.getFinalPriceRoute();

        if(this.booking.bookingStrategyAdapter.supportsPayment && this.booking.bookingStrategyAdapter.hideFinalPriceStep && route.equals(finalPriceRoute)) {
            const paymentRoute = this.booking.bookingStrategyAdapter.getPaymentRoute();
            super._activateStepByRoute(paymentRoute, activateOptions);
        } else {
            super._activateStepByRoute(route, activateOptions)
        }
    }

    protected _shouldAskForConfirmationWhenLeavingBookingFlow(context: IOnBeforeDeactivationContext): boolean {
        return this.booking.hasPurchasesOnCurrentSession;
    }

    async onBeforeDeactivation(context: IOnBeforeDeactivationContext): Promise<DialogResult> {
        if(this.services.navigator.isBookingRoute(context.routingGuardContext.targetLocation.pathname)) {
            return await super.onBeforeDeactivation(context);
        }

        if(!this._shouldAskForConfirmationWhenLeavingBookingFlow(context)) {
            return DialogResult.Accepted;
        }

        const dialogResult = await this.services.dialogFactory.showYesNoDialog({
            title: this.services.language.translate('Confirmation'),
            message: this.services.language.translate('Are you sure you want leave this booking?'),
            primaryButton: YesNoDialogPrimaryButton.PrimaryButtonNo,
        });

        if(dialogResult === YesNoDialogResult.No) {
            return DialogResult.Rejected;
        } else {
            return DialogResult.Accepted;
        }
    }

}
